/**
 * A review's own action items — see migration 135.
 *
 * Up to six, each a title and a line about it, entered on the review form and
 * shown on the Action Items slide after the audit recommendations.
 */
export interface ActionItem {
  title: string;
  detail: string;
}

/** Rows on the form, and the most the API accepts. */
export const ACTION_ITEM_SLOTS = 6;

export const emptyActionItems = (): ActionItem[] =>
  Array.from({ length: ACTION_ITEM_SLOTS }, () => ({ title: '', detail: '' }));

/** Never throws: a malformed value reads as none. Padded to six for the form. */
export function parseActionItems(raw: string | null | undefined): ActionItem[] {
  const out = emptyActionItems();
  if (!raw) return out;
  try {
    const parsed = JSON.parse(raw) as unknown;
    if (Array.isArray(parsed)) {
      parsed.slice(0, ACTION_ITEM_SLOTS).forEach((item, i) => {
        const v = item as Partial<ActionItem> | null;
        out[i] = {
          title: typeof v?.title === 'string' ? v.title : '',
          detail: typeof v?.detail === 'string' ? v.detail : '',
        };
      });
    }
  } catch {
    /* fall through to none */
  }
  return out;
}

/** The rows with anything in them, in the order they were entered. */
export const filledActionItems = (items: ActionItem[]): ActionItem[] =>
  items.filter((i) => i.title.trim() !== '' || i.detail.trim() !== '');
